import type { Translation } from '../translations.types';

const translations: Translation = {
  logout: 'Esci',
  author: 'Pubblicato da',
  'add-review': 'Mmm! Condividi la tua esperienza culinaria!',
  'add-review-to-food': 'Raccontaci la tua esperienza con {{food}}',
  food: {
    title: 'Cibo',
    gourmets: 'Fan di {{food}}',
    bestPlaces: 'Migliori posti per {{food}}',
    gourmetsSectionDescription:
      "Scopri chi conosce bene {{food}}! I nostri buongustai sono classificati in base a quante volte l'hanno provato e cosa ne hanno pensato.",
    bestPlacesSectionDescription:
      'Cerchi {{food}} incredibile? Questi posti sono valutati da persone che se ne intendono!',
    beTheFirstReviewer: {
      title: 'Sii il primo a recensire {{foodName}}!',
      description: 'La tua esperienza culinaria è importante! Condividi la tua recensione e aiuta altri buongustai a scoprire questo piatto.',
      button: 'Scrivi la prima recensione'
    }
  },
  drink: 'Bevanda',
  place: 'Luogo',
  'where-did-you-eat': 'Dove hai mangiato questo?',
  'what-did-you-eat': 'Cosa hai provato?',
  localeCurrency: 'Valuta locale',
  category: 'Categoria',
  name: 'Nome',
  rating: 'Il tuo voto',
  welcome_modal: {
    title: 'Benvenuto su BiteCritic!',
    subtitle: 'Scopri il tuo prossimo piatto preferito',
    description:
      'BiteCritic è una comunità di amanti del cibo che condividono le loro esperienze e valutano il cibo che hanno provato.',
    features: {
      title: 'Con BiteCritic, puoi:',
      rate: 'Valutare i piatti in base al gusto, non solo i ristoranti',
      discover: 'Scoprire nuovi cibi basati su recensioni autentiche',
      connect: 'Connetterti con altri appassionati di cibo',
      track: 'Tenere traccia dei cibi che vuoi provare',
    },
    not_now: 'Non ora',
    join_now: 'Unisciti ora',
  },
  review: {
    label: 'La Tua Opinione',
    writingIn: 'Sto scrivendo questa recensione in',
    success: 'La tua storia è online!',
    error:
      'Ops! Qualcosa è andato storto durante la condivisione della tua storia',
    foodReviewTitle:
      'Recensione di {{foodName}} di {{username}} presso {{placeName}}, {{city}}',
    drinkReviewTitle:
      'Recensione di {{drinkName}} di {{username}} presso {{placeName}}, {{city}}',
  },
  previous: 'Indietro',
  next: 'Avanti',
  'submit-review': 'Condividi la tua storia',
  cancel: 'Annulla',
  type: 'Che tipo',
  'add-food-review': 'Cosa hai mangiato?',
  'select-food': 'Scegli il tuo piatto',
  cost: 'Quanto?',
  'rating-explanation': 'Valuta la tua esperienza con questo piatto.',
  'write-your-review': 'Raccontaci tutto...',
  'visited-at': 'Quando ci sei stato?',
  reviews: {
    noReviews: 'Nessuna recensione trovata',
    readFull: 'Leggi la storia completa',
    showTranslation: 'Mostra traduzione',
    showOriginal: 'Mostra originale',
    translatedFrom: 'Tradotto da {{language}}',
    filters: {
      title: 'Filtri',
      apply: 'Applica filtri',
      rating: 'Valutazione',
      cost: 'Costo',
      startDate: 'Da',
      endDate: 'A',
      location: 'Posizione',
      radius: 'Raggio di ricerca (km)',
      sort: {
        label: 'Ordina per',
        newest: 'Più recenti prima',
        oldest: 'Più vecchi prima',
        mostLiked: 'Più apprezzati',
        leastLiked: 'Meno apprezzati',
        mostExpensive: 'Più costosi',
        cheapest: 'Meno costosi',
      },
      sortOrder: {
        asc: 'crescente',
        desc: 'decrescente',
      },
      sortBy: {
        createdAt: 'Data',
        likeCount: 'Mi piace',
        cost: 'Prezzo',
      },
      active: {
        rating: 'Valutazione minima: {{value}}',
        startDate: 'Da: {{date}}',
        endDate: 'A: {{date}}',
        cost: 'Costo minimo: {{value}}',
        radius: 'Entro {{value}}km',
      },
    },
  },
  languages: {
    en: 'Inglese',
    nl: 'Olandese',
    tr: 'Turco',
    de: 'Tedesco',
    fr: 'Francese',
    es: 'Spagnolo',
    it: 'Italiano',
    pt: 'Portoghese',
    select: 'Seleziona lingua',
  },
  validation: {
    'place-required': 'Ops! Scegli prima un luogo',
    'category-required': 'Scegli una categoria!',
    'review-min-length':
      "Un po' più di dettagli sarebbero ottimi (almeno 80 caratteri)",
    'rating-required': 'Non dimenticare di valutarlo!',
    'cost-positive': 'Il prezzo deve essere maggiore di zero',
    'visited-at-required': 'Quando ci sei stato?',
    'type-required': 'Cibo o bevanda?',
    'food-required': 'Cosa hai mangiato?',
    'drink-required': 'Cosa hai bevuto?',
    'country-required': 'Da dove vieni?',
    required: 'Questo campo è obbligatorio',
  },
  auth: {
    welcomeBack: 'Ciao! 👋',
    loginToContinue: 'Accedi di nuovo',
    continueWithGoogle: 'Continua con Google',
    continueWithApple: 'Continua con Apple',
    logout: 'A presto!',
    login: 'Accedi',
    signup: 'Unisciti alla festa del cibo!',
    required: 'Iniziamo!',
    actionRequiresAuth: 'Ops! È necessario un rapido accesso per questo',
    alreadyLoggedIn: "Hai già effettuato l'accesso!",
    goToProfile: 'Vai al Profilo',
    continueToFeed: 'Continua al Feed',
    benefits: {
      title: 'Ecco cosa ti stai perdendo:',
      follow: 'Segui i tuoi cibi preferiti',
      review: 'Condividi le tue avventure culinarie',
      save: 'Salva luoghi per dopo',
      community: 'Incontra altri amanti del cibo',
      personalized: 'Ricevi consigli sul cibo solo per te',
    },
    cta: {
      login: 'Andiamo!',
      cancel: 'Forse più tardi',
    },
    actions: {
      followFood: 'Accesso rapido per seguire questo delizioso piatto!',
      unfollowFood: 'Accedi per smettere di seguire',
    },
    joinNow: 'Unisciti ora!',
    joinCommunity: 'Unisciti alla festa del cibo!',
    alreadyHaveAccount: 'Hai già un account?',
    signupToContinue: 'Unisciti alla festa del cibo!',
  },
  profile: {
    follow: 'Segui',
    unfollow: 'Smetti di seguire',
    followers: 'Follower',
    following: 'Seguiti',
    avatar: 'La tua foto',
    change_avatar: 'Nuova foto',
    upload_avatar: 'Carica foto',
    title: 'Il tuo profilo',
    view: 'Visualizza profilo',
    username: 'Nome utente',
    email: 'Email',
    success: 'Sembra buono!',
    error: 'Ops, qualcosa è andato storto',
    save: 'Salva',
    firstName: 'Nome',
    lastName: 'Cognome',
    birthDate: 'Data di nascita',
    country: 'Paese',
    bio: 'Su di te',
    bioPlaceholder: 'Raccontaci delle tue avventure culinarie...',
    selectCountry: 'Seleziona il tuo paese',
    deleteAccount: {
      button: 'Elimina account',
      title: 'Elimina il tuo account',
      warning:
        'Attenzione: questa azione non può essere annullata. Tutti i tuoi dati, recensioni e preferenze verranno eliminati definitivamente.',
      confirm: 'Elimina il mio account',
      error: "Impossibile eliminare l'account. Riprova più tardi.",
    },
    noAccount: 'Non hai un account?',
  },
  errors: {
    invalidFileType:
      'Tipo di file non valido. Carica solo immagini JPG, PNG, WebP, HEIC o HEIF.',
    fileTooLarge: 'Il file è troppo grande. La dimensione massima è {{size}}.',
    tooManyFiles: 'Troppi file. Il massimo consentito è {{max}}.',
  },
  onboarding: {
    welcome: 'Benvenuto su BiteCritic!',
    setup_profile: 'Configuriamo il tuo profilo',
    username: 'Nome utente',
    username_required: 'Il nome utente è obbligatorio',
    username_min_length: 'Il nome utente deve contenere almeno 3 caratteri',
    username_pattern: 'Sono consentiti solo lettere, numeri e underscore',
    username_taken: 'Questo nome utente è già in uso',
    username_available: 'Nome utente disponibile!',
    username_requirements:
      'Il nome utente deve contenere almeno 3 caratteri e può contenere solo lettere, numeri e underscore',
    checking_username: 'Verifica della disponibilità del nome utente...',
    first_name: 'Nome',
    first_name_required: 'Il nome è obbligatorio',
    first_name_min_length: 'Il nome deve contenere almeno 2 caratteri',
    first_name_max_length: 'Il nome deve contenere al massimo 20 caratteri',
    last_name: 'Cognome',
    last_name_required: 'Il cognome è obbligatorio',
    last_name_min_length: 'Il cognome deve contenere almeno 2 caratteri',
    last_name_max_length: 'Il cognome deve contenere al massimo 20 caratteri',
    birth_date: 'Data di nascita',
    birth_date_required: 'La data di nascita è obbligatoria',
    country: 'Paese',
    complete_profile: 'Completa profilo',
    success: 'Profilo aggiornato con successo!',
    error: 'Impossibile aggiornare il profilo',
  },
  language: {
    select: 'Scegli la tua lingua',
    select_country: 'Dove sei?',
    select_language: 'Quale lingua?',
    current: 'Lingua attuale',
  },
  categories: {
    title: 'Categorie di cibo',
    meta: {
      title: 'Categorie di cibo - Scopri delizie culinarie',
      description:
        'Esplora le nostre diverse categorie di cibo e scopri delizie culinarie da tutto il mondo. Trova recensioni, valutazioni e dove gustarle.',
      categoryTitle: 'Categoria di cibo',
      categoryDescription:
        'Esplora {{category}} - Scopri {{count}} deliziosi cibi in questa categoria con recensioni e valutazioni da amanti del cibo.',
      keywords:
        'categorie di cibo, tipi di cucina, esplorazione culinaria, scoperta di cibo',
      loading: 'Caricamento categoria',
      defaultDescription:
        'Esplora le nostre diverse categorie di cibo e trova la tua prossima avventura culinaria.',
    },
  },
  common: {
    noMoreReviews: 'Non ci sono più recensioni',
    save: 'Salva',
    error: {
      default: 'Oops!',
      fetchFailed: 'Impossibile recuperare i dati',
      rateLimitExceeded:
        'Troppe richieste. Attendi un momento prima di riprovare.',
    },
    search: 'Cerca',
    back: 'Indietro',
    cancel: 'Annulla',
    loading: 'Caricamento...',
    delete: 'Elimina',
    create: 'Create It',
    open: 'Aperto',
    closed: 'Chiuso',
    country: 'Paese',
    reviews: 'Recensioni',
    reviews_count: '{{count}} buongustai hanno provato questo',
    showMore: 'Mostra di più',
    showLess: 'Mostra di meno',
    uploadImage: 'Carica immagine',
    uploadMedia: 'Carica media',
    deleteMedia: 'Elimina media',
    uploadedMedia: 'Media caricato',
    sort: 'Ordina per',
    loadMore: 'Carica altro',
    backToHome: 'Torna alla home',
    actions: {
      share: {
        label: 'Condividi',
        copied: 'Link copiato negli appunti',
        copyFailed: 'Impossibile copiare il link',
      },
    },
    exploreMore: 'Esplora Altro',
    discoverExperiences: 'Scopri nuove esperienze culinarie',
    reachedEndOfContent: 'Hai raggiunto la fine di questo contenuto',
    comingSoon: 'Coming Soon',
    notNow: 'Not Now',
    close: 'Close',
    saveChanges: 'Save Changes',
    food: 'food',
    previous: 'Previous',
    next: 'Next',
  },
  statuses: {
    active: 'Attivo',
    pending: 'In attesa',
    rejected: 'Rifiutato',
  },
  places: {
    radius: 'Distanza',
    noPlacesFound: 'Niente qui per ora',
    tryAdjustingFilters: 'Prova a modificare le tue opzioni di ricerca',
    locationPermission: {
      title: 'Dove sei?',
      description:
        'Condividi la tua posizione per trovare posti deliziosi nelle vicinanze',
      allow: 'Mostra la mia posizione',
    },
    whereDidYouEat: 'Dove hai mangiato questo?',
    searchByLocation: 'Dove vuoi andare?',
    selectPlace: 'Digita il nome di un luogo',
    yourLocation: 'Sei qui',
    searchOrUseLocation:
      'Cerca un luogo specifico o usa la tua posizione per scoprire posti nelle vicinanze',
    locationStatus: {
      detecting: 'Rilevamento della tua posizione...',
      denied: 'Accesso alla posizione negato',
      unavailable: 'Posizione non disponibile',
      found: 'Posizione trovata!',
    },
    sort: {
      title: 'Ordina per',
      ratingDesc: 'Valutazione più alta', 
      ratingAsc: 'Valutazione più bassa',
      distanceAsc: 'Più vicini prima',
      distanceDesc: 'Più lontani prima',
      nameAsc: 'Nome (A-Z)',
      nameDesc: 'Nome (Z-A)',
      reviewCountDesc: 'Più recensiti',
      reviewCountAsc: 'Meno recensiti',
      newestFirst: 'Più recenti prima',
      oldestFirst: 'Più vecchi prima',
    },
    period: {
      title: 'Periodo',
      ALL_TIME: 'Tutto il tempo',
      LAST_WEEK: 'Ultima settimana',
      LAST_MONTH: 'Ultimo mese',
      LAST_YEAR: 'Ultimo anno',
    },
    meta: {
      title: 'Scopri ristoranti vicino a te',
      description: 'Trova ed esplora i migliori ristoranti nella tua zona. Leggi recensioni, guarda foto e scopri nuove esperienze gastronomiche.',
      titleWithPlace: 'Migliori posti vicino a {{place}}',
      descriptionWithPlace: 'Scopri i migliori ristoranti e locali gastronomici vicino a {{place}} entro {{radius}} km. Leggi recensioni, consulta valutazioni e trova il tuo prossimo posto preferito dove mangiare.'
    },
    navigation: {
      title: 'Luoghi',
    },
    detail: {
      error: 'Ops! Non siamo riusciti a trovare questo luogo. Riprova?',
      sections: {
        popularFoods: {
          title: 'I più apprezzati presso {{place}}',
          description:
            'Questi piatti sono i più apprezzati dalla nostra comunità di buongustai presso {{place}}. Classificati per valutazioni e numero di recensioni.',
          titleWithCity: 'I più apprezzati presso {{place}} in {{city}}',
          descriptionWithCity:
            'Questi piatti sono i più apprezzati dalla nostra comunità di buongustai presso {{place}} in {{city}}. Classificati per valutazioni e numero di recensioni.',
        },
        gourmets: {
          title: 'Migliori buongustai presso {{place}}',
          description:
            'Incontra gli amanti del cibo che conoscono meglio {{place}}. Sono classificati in base al numero di recensioni e valutazioni.',
          titleWithCity: 'Migliori buongustai presso {{place}} in {{city}}',
          descriptionWithCity:
            'Incontra gli amanti del cibo che conoscono meglio {{place}} in {{city}}. Sono classificati in base al numero di recensioni e valutazioni.',
        },
        reviews: {
          title: 'Recensioni presso {{place}}',
          titleWithCity: 'Recensioni presso {{place}} in {{city}}',
        },
      },
    },
    emptyState: {
      title: 'Nessun posto trovato',
      description: '{{username}} non ha ancora recensito alcun posto.'
    },
    userMapTitle: 'Mappa gastronomica di {{username}}',
    reviewsDrawer: {
      title: 'Recensioni per {{placeName}}',
      noReviews: 'Ancora nessuna recensione per questo posto.',
      viewMore: 'Visualizza tutte le recensioni',
      addReview: 'Aggiungi recensione'
    },
    viewAllVisited: 'Tutti i posti che {{username}} ha visitato e valutato'
  },
  settings: {
    title: 'Le tue impostazioni',
  },
  home: 'Home',
  'review-not-found': 'Impossibile trovare questa recensione',
  'go-back': 'Indietro',
  actions: {
    share: 'Condividi con amici',
  },
  users: {
    title: 'Appassionati di Cibo',
    searchPlaceholder: 'Cerca per nome...',
    noResults: 'Nessun appassionato di cibo trovato',
    seoTitle: 'Critici Gastronomici e Recensori',
    seoDescription:
      'Scopri critici gastronomici e recensori nella tua zona. Connettiti con appassionati di cibo che condividono le tue passioni culinarie e scopri nuove esperienze gastronomiche.',
    seoKeywords:
      'critici gastronomici, recensori di cibo, esperti culinari, appassionati di cibo, buongustai',
    navigation: {
      title: 'Foodies',
    },
    stats: {
      followers: 'Follower',
      following: 'Seguiti',
      rating: 'Valutazione',
      reviews: 'Recensioni',
    },
    map: {
      viewMap: 'Visualizza Mappa Gastronomica',
      seoTitle: 'Mappa gastronomica di {{username}}',
      seoDescription: 'Esplora i luoghi che {{username}} ha visitato e valutato sulla sua mappa gastronomica.'
    },
    detail: {
      sections: {
        visitedPlaces: {
          title: 'Luoghi Recenti di {{username}}',
          description: 'Posti in cui {{username}} ha condiviso esperienze culinarie',
        },
        likedFoods: {
          title: 'Cibi Preferiti di {{username}}',
          description: 'Piatti che {{username}} ha provato e recensito',
        },
      },
    },
  },
  foods: {
    title: 'Piatti',
    meta: {
      title: 'Scopri piatti vicino a te',
      description:
        'Esplora e scopri deliziosi piatti nella tua zona. Sfoglia recensioni, valutazioni e foto di vari piatti dai ristoranti locali.',
    },
    searchPlaceholder: 'Cerca piatti...',
    noResults: 'Nessun piatto trovato',
    sort: {
      nameAsc: 'Nome A-Z',
      nameDesc: 'Nome Z-A',
      ratingDesc: 'Più votati',
      ratingAsc: 'Meno votati',
      reviewCountDesc: 'Più recensioni',
      reviewCountAsc: 'Meno recensioni',
    },
    period: {
      allTime: 'Tutto il tempo',
      lastWeek: 'Ultima settimana',
      lastMonth: 'Ultimo mese',
      lastYear: 'Ultimo anno',
    },
  },
  navigation: {
    home: 'Home',
    discover: 'Scopri',
    community: 'Comunità',
    support: 'Supporto',
    myProfile: 'Il mio profilo',
    myFeed: 'Il mio feed',
    gourmets: 'Trova buongustai',
    placesNearMe: 'Luoghi vicino a me',
    foodsNearMe: 'Piatti vicino a me',
    popularPlacesMonth: 'Luoghi più votati del mese',
    mostReviewedPlacesMonth: 'Luoghi più recensiti del mese',
    popularGourmetsMonth: 'Buongustai popolari del mese',
    popularFoodsMonth: 'Piatti popolari del mese',
    popular: 'Popolare',
    contact: 'Contatti',
    privacy: 'Informativa sulla Privacy',
    terms: 'Termini e Condizioni',
  },
  error: {
    pageNotFound: 'Pagina non trovata',
    pageNotFoundDescription:
      'La pagina che stai cercando potrebbe essere stata rimossa, ha cambiato nome o è temporaneamente non disponibile.',
    needHelp: 'Hai bisogno di aiuto?',
    contactUs:
      'Contatta il nostro team di supporto e ti aiuteremo a trovare ciò che stai cercando.',
  },
  contact: {
    title: 'Contattaci',
    name: 'Il tuo nome',
    email: 'Indirizzo email',
    message: 'Messaggio',
    send: 'Invia messaggio',
    nameRequired: 'Inserisci il tuo nome',
    emailRequired: 'Inserisci la tua email',
    emailInvalid: "Inserisci un'email valida",
    messageRequired: 'Inserisci il tuo messaggio',
    pageTitle: 'Mettiti in contatto',
    pageDescription:
      "Hai domande o hai bisogno di assistenza? Siamo qui per aiutarti! Compila il modulo sottostante o inviaci un'email direttamente.",
  },
  seo: {
    keywords: {
      food: 'cibo',
      cuisine: 'cucina',
      reviews: 'recensioni',
      rating: 'valutazione',
      restaurants: 'ristoranti',
      dining: 'ristorazione',
    },
    food: {
      title: 'Recensione {{foodName}}',
      description:
        'Scopri i migliori posti dove mangiare {{foodName}}. Leggi recensioni sincere e trova dove gustare il più delizioso {{foodName}} vicino a te su BiteCritic.',
      defaultDescription:
        'Scopri {{foodName}} - recensioni, valutazioni e dove trovare il miglior {{foodName}} vicino a te.',
    },
    place: {
      defaultDescription:
        'Esplora {{placeName}} - recensioni, valutazioni e piatti popolari in questo luogo.',
      cityDescription:
        'Esplora {{placeName}} in {{cityName}} - recensioni, valutazioni e piatti popolari in questo luogo.',
    },
    review: {
      defaultDescription:
        'Leggi la recensione di {{username}} su {{foodName}} presso {{placeName}} - valutazioni, foto ed esperienza dettagliata.',
      foodTitle:
        'Recensione di {{foodName}} presso {{placeName}} - {{rating}}/10',
      placeTitle: 'Recensione di {{placeName}} - {{rating}}/10',
      metaDescription:
        'Leggi la recensione dettagliata di {{username}} su {{foodName}} presso {{placeName}}. Valutazione: {{rating}}/10. Scopri cosa rende speciale questo {{type}}.',
      authorTitle:
        'Recensione di {{username}} su {{foodName}} presso {{placeName}}',
      ratingScale: 'Scala di valutazione: 0-10',
      reviewedType: {
        food: 'Piatto',
        restaurant: 'Ristorante',
        product: 'Prodotto',
      },
    },
    user: {
      defaultDescription:
        'Scopri il percorso culinario di {{username}} - recensioni, piatti preferiti e avventure culinarie.',
    },
    category: {
      defaultDescription:
        'Esplora i piatti di {{categoryName}} - scopri i migliori piatti, recensioni e dove trovarli vicino a te.',
    },
    meta: {
      siteName: 'BiteCritic',
      defaultTitle: 'BiteCritic - Scopri e condividi esperienze culinarie',
      defaultDescription:
        'Unisciti agli amanti del cibo di tutto il mondo per scoprire e condividere incredibili esperienze culinarie. Trova recensioni autentiche, valutazioni e foto di piatti vicino a te.',
      defaultKeywords:
        'cibo, ristoranti, recensioni, gastronomia, cucina, critici gastronomici',
    },
  },
  feed: {
    title: 'Il tuo percorso culinario personale',
    description:
      'Segui i tuoi piatti, luoghi e buongustai preferiti per creare il tuo feed culinario perfetto. Ottieni consigli personalizzati e non perdere mai un buon pasto.',
    discover: 'Inizia a scoprire',
    personalizedTitle: 'Il tuo feed culinario',
    allReviewsTitle: 'Ultime storie culinarie',
    personalizedDescription:
      'Visualizza le recensioni dei piatti, luoghi e buongustai che segui.',
    joinCommunityDescription:
      'Unisciti alla nostra comunità per un feed personalizzato basato sui tuoi interessi.',
    noRelatedReviews:
      'Non abbiamo ancora recensioni che corrispondono ai tuoi interessi. Scopriamo alcune storie globali!',
    showGlobalFeed: 'Mostra feed globale',
    myFeed: 'Il mio feed',
    globalFeed: 'Feed globale',
    globalDescription: 'Scopri le ultime storie culinarie da tutto il mondo.',
    noGlobalReviews:
      'Nessuna recensione globale disponibile al momento. Torna presto!',
    meta: {
      title: 'Feed culinario - Il tuo percorso culinario personalizzato',
      description:
        'Scopri le ultime recensioni e storie culinarie dai tuoi piatti, luoghi e buongustai preferiti. Ottieni consigli personalizzati basati sui tuoi gusti.',
      keywords:
        'feed culinario, recensioni di cibo, consigli personalizzati, storie culinarie, comunità culinaria',
    },
    followFoods: {
      title: 'Segui piatti',
      description:
        'Tieni traccia dei tuoi piatti preferiti e scopri nuove varianti.',
    },
    followPlaces: {
      title: 'Segui luoghi',
      description:
        'Resta aggiornato sulle ultime recensioni dei tuoi posti preferiti.',
    },
    followGourmets: {
      title: 'Segui buongustai',
      description:
        'Connettiti con amanti del cibo che condividono i tuoi gusti e scopri i loro consigli.',
    },
  },
  download: {
    ios_app: 'Scarica App iOS',
    android_app: 'Scarica App Android',
  },
  notifications: {
    title: 'Notifiche',
    pageTitle: 'Notifiche',
    pageDescription: 'Gestione le tue notifiche',
    markAllAsRead: 'Segna tutti come letti'
  },
  endOfScroll: {
    placesNearMe: 'Luoghi Vicini',
    placesNearMeSubtitle: 'Trova ristoranti e locali nelle vicinanze',
    globalFeed: 'Feed Globale',
    globalFeedSubtitle: 'Guarda cosa piace agli altri',
    findPeople: 'Trova Buongustai',
    findPeopleSubtitle: 'Connettiti con altri appassionati di cibo',
    foodsNearMe: 'Piatti Vicini',
    foodsNearMeSubtitle: 'Scopri piatti popolari nella tua zona',
  },
  'media': 'Media',
  'media.image': 'Image',
  'media.video': 'Video',
  'location': 'Luogo',
  // New review modal step explanations
  'review-modal-media-explanation': 'Scatta una foto o scegline una dal tuo album per mostrare il tuo piatto!',
  'review-modal-rating-explanation': 'Che sapore aveva? Dai la tua valutazione onesta.',
  'review-modal-location-explanation': 'Dove hai gustato questo piatto? Fallo sapere agli altri!',
  // Draft management
  'draft-cleared': 'Bozza cancellata con successo!',
  'draft-save-error': 'Ops! Impossibile salvare la tua bozza',
  'clear-draft': 'Cancella bozza',
  comments: {
    title: 'Commenti',
    subtitle: 'Partecipa alla conversazione',
    writeComment: 'Scrivi un commento...',
    submit: 'Pubblica',
    delete: 'Elimina',
    noComments: 'Ancora nessun commento. Sii il primo a commentare!',
    loginToComment: 'Accedi per lasciare un commento',
    loadMore: 'Carica altri',
    commentAdded: 'Commento aggiunto con successo',
    commentError: 'Impossibile aggiungere il commento',
    commentDeleted: 'Commento eliminato',
    deleteError: 'Impossibile eliminare il commento',
    post: 'Pubblica',
    placeholder: 'Scrivi un commento...',
  },
  mentions: {
    noUsersFound: 'Nessun utente trovato',
    searchingUsers: 'Cerca utenti...',
  },
  openMenu: 'Apri menu',
  closeMenu: 'Chiudi menu',
  app: {
    actions: 'App Actions',
  },
};

export default translations;
